import { axiosV2, getError, getResponse, settings } from '../../helpers/UtilsHelper';

const { app } = settings;
const { urls } = app?.backend;

export class LargeLanguageModelService {

    static getAll = async ({
        token = '',
        data = {},
        languageId = 'en',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'LargeLanguageModelService - getAll';
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.largeLanguageModels}/`;
            const headers = { authorization: `bearer ${token}`, languageId: languageId };
            response = await axiosV2?.post({
                url: url,
                data: data,
                headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    static getById = async ({
        id = '',
        token = '',
        languageId = 'en',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'LargeLanguageModelService - getById';
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.largeLanguageModels}/${id}`;
            const headers = { authorization: `bearer ${token}`, languageId: languageId };
            response = await axiosV2?.get({
                url: url,
                headers: headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    static deleteById = async ({
        id = '',
        token = '',
        languageId = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'LargeLanguageModelService - deleteById';
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.largeLanguageModels}/${id}`;
            const headers = { authorization: `bearer ${token}`, languageId: languageId };
            response = await axiosV2?.delete({
                url: url,
                headers: headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    static create = async ({
        token = '',
        data = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'LargeLanguageModelService - create';
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.largeLanguageModels}/`;
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.post({
                url: url,
                data: data,
                headers: headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    static update = async ({
        id = '',
        token = '',
        data = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'LargeLanguageModelService - update';
        let response = getResponse({ type: 0 });
        try {
            const url = `${urls?.url}${urls?.apiV1}${urls?.largeLanguageModels}/${id}`;
            const headers = { authorization: `bearer ${token}` };
            response = await axiosV2?.post({
                url: url,
                data: data,
                headers: headers,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return response;

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }
}
